import styled, { css } from "styled-components";
import { type WidthProps, width } from "styled-system";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as CheckboxStyle from "../../../../../../../common-deprecated/styles/v2/lexus/components/Input";
import { bodyStyle, type TextStyleType } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

// List
export const List = styled.ul.attrs(() => ({
    className: "list-unstyled",
}))`
    padding-left: 0;
    &:not(:last-of-type) {
        margin-bottom: ${theme.space[4]}px !important; /* Added an !important to override CSS */
    }

    html[dir="rtl"] & {
        padding-right: 0;
    }
`;

export const ListItem = styled.li<WidthProps>`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${theme.space[3]}px !important; /* Adden an !important to override CSS */
    ${width}

    &:last-child {
        margin-bottom: 0px !important;
    }
`;

// Checkbox style

export const Checkbox = styled(CheckboxStyle.Checkbox)<TextStyleType & { disabled?: boolean }>`
    ${bodyStyle};

    &::before {
        width: 24px;
        height: 24px;
        background-color: ${theme.colors.platinumLight};
    }

    ${(props) =>
        props.disabled &&
        css`
            color: ${theme.colors.platinumDark};
            cursor: default;
            &::before {
                background-color: ${theme.colors.mist};
                border: none;
            }
        `}
`;

// eslint-disable-next-line prefer-destructuring
export const Wrapper = styled(CheckboxStyle.Wrapper)`
    input:checked ~ ${Checkbox} {
        &::before {
            width: 24px;
            height: 24px;
            background-color: ${theme.colors.midnight};
            background-image: url("data:image/svg+xml,%3Csvg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='0.353553' y1='4.415' x2='3.58459' y2='7.64604' stroke='white'/%3E%3Cline x1='2.89122' y1='7.63409' x2='10.4303' y2='0.633505' stroke='white'/%3E%3C/svg%3E%0A");
        }
    }
    label {
        padding-top: 6px;
        padding-left: 32px;
    }
`;

export const Counter = styled.span.attrs(() => ({
    className: "l-nano-text",
}))<{ disabled?: boolean }>`
    display: inline-block;
    margin-left: ${theme.space[2]}px;
    color: ${({ disabled }) => (disabled ? theme.colors.platinumDark : theme.colors.titanium)};

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[2]}px;
    }
`;
